module.exports = __webpack_public_path__ + "08ff1a8b09eed3b2b7a6f0ce8fbda1b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-6.jpg
// module id = 1179
// module chunks = 0